const passwordSecurityBasics = {
  slug: 'password-security-basics',
  title: 'Password security basics',
  description:
    'Why unique, strong passwords matter — especially after a suspicious call — and how to reduce the damage if a scammer phishes you.',
  category: 'digital',
  guideType: 'guide',
  readMinutes: 4,
  partnerTip: 'compact',
  relatedSlugs: ['password-managers', 'two-factor-authentication', 'after-a-scam-call'],
  sections: [
    {
      type: 'paragraph',
      text: 'Phone scams often aim at your money today and your accounts tomorrow. If you reuse passwords, one mistake on a fake login page can unlock email, banking, and shopping accounts.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Use a unique password for every account',
    },
    {
      type: 'paragraph',
      text: 'When a site is breached or you enter a password on a phishing site, criminals try that email and password combination everywhere else. Uniqueness limits the blast radius.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Length beats clever tricks',
    },
    {
      type: 'paragraph',
      text: 'Long passphrases or randomly generated passwords resist guessing better than short passwords with symbols. Let a password manager generate them.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'After a suspicious call',
    },
    {
      type: 'list',
      items: [
        'Change passwords for any account you discussed or logged into',
        'Start with email — it is often the recovery key for other services',
        'Enable two-factor authentication where available',
      ],
    },
    {
      type: 'link',
      to: '/learn/after-a-scam-call',
      label: 'Full checklist: after a scam call',
    },
    {
      type: 'link',
      to: '/learn/password-managers',
      label: 'How password managers help',
    },
  ],
};

export default passwordSecurityBasics;
